import request from '@/utils/request'

// 标签列表
export function material_tag_index(data) {
  return request({
    url: '/merchant/ManagerMaterialTag/index',
    method: 'get',
    params: data
  })
}

// 标签添加
export function material_tag_add(data) {
  return request({
    url: '/merchant/ManagerMaterialTag/add',
    method: 'post',
    data: data
  })
}

// 标签修改
export function material_tag_edit(data) {
  return request({
    url: '/merchant/ManagerMaterialTag/edit',
    method: 'post',
    data: data
  })
}

// 标签删除
export function material_tag_del(data) {
  return request({
    url: '/merchant/ManagerMaterialTag/del',
    method: 'post',
    data: data
  })
}

// 素材列表
export function material_index(data) {
  return request({
    url: '/merchant/ManagerMaterial/index',
    method: 'get',
    params: data
  })
}

// 素材添加
export function material_add(data) {
  return request({
    url: '/merchant/ManagerMaterial/add',
    method: 'post',
    data: data
  })
}

// 素材修改
export function material_edit(data) {
  return request({
    url: '/merchant/ManagerMaterial/edit',
    method: 'post',
    data: data
  })
}

// 素材删除
export function material_del(data) {
  return request({
    url: '/merchant/ManagerMaterial/del',
    method: 'post',
    data: data
  })
}

// 素材上传获取凭证 (New Path)
export function material_upload(data) {
  return request({
    url: '/merchant/common/uploader', // Fixed: use the correct existing uploader path
    method: 'get',
    params: data
  })
}

// 素材项目列表
export function material_item_index(data) {
  return request({
    url: '/merchant/ManagerMaterialItem/index',
    method: 'get',
    params: data
  })
}

// 素材项目添加
export function material_item_add(data) {
  return request({
    url: '/merchant/ManagerMaterialItem/add',
    method: 'post',
    data: data
  })
}

// 素材项目修改
export function material_item_edit(data) {
  return request({
    url: '/merchant/ManagerMaterialItem/edit',
    method: 'post',
    data: data
  })
}

// 素材项目删除
export function material_item_del(data) {
  return request({
    url: '/merchant/ManagerMaterialItem/del',
    method: 'post',
    data: data
  })
}

// 分类列表
export function material_category_index(data) {
  return request({
    url: '/merchant/ManagerMaterialCategory/index',
    method: 'get',
    params: data
  })
}

// 品牌列表
export function material_brand_index(data) {
  return request({
    url: '/merchant/ManagerMaterialBrand/index',
    method: 'get',
    params: data
  })
}
